module.exports = __webpack_public_path__ + "media/assets/avia/search/aeroplane-a598a3810766d0ab3656452fb3eea78d.svg";